export default (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[Strona główna]]]').after('[[[Zmiana hasła]]]', [
        {
            name: '[[[Powiadomienia]]]',
            route: 'core-account-notifications',
            icon: 'far fa-fw fa-envelope-open'
        }
    ]);

    sitemap.find('[[[System]]]', '[[[Ustawienia]]]').after('[[[Poczta wychodząca]]]', [
        {
            name: '[[[Powiadomienia]]]',
            route: 'notices-settings',
            icon: 'far fa-fw fa-shield-alt',
            auth: { all: [], any: [] }
        }
    ]);

    sitemap.find('[[[System]]]').after('[[[Administracja]]]', [
        {
            name: '[[[Centrum powiadomień]]]',
            icon: 'far fa-fw fa-bell',
            children: [
                {
                    name: '[[[Wysyłka wiadomości]]]',
                    route: 'core-notifications-broadcasting',
                    icon: 'far fa-fw fa-ballot-check',
                    namespace: 'Ideo.Core.Common.Application.Data.Core.CollectiveNotifications.Permissions',
                    auth: { all: ['CollectiveNotificationsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodaj wiadomość]]]',
                            route: 'core-notifications-broadcasting-add',
                            auth: { all: ['CollectiveNotificationsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edytuj wiadomość]]]',
                            route: 'core-notifications-broadcasting-edit',
                            auth: { all: ['CollectiveNotificationsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Typy powiadomień]]]',
                    route: 'core-notifications-types',
                    icon: 'far fa-fw fa-ballot-check',
                    auth: { all: ['NotificationsPermissions@Access'], any: [] },
                    children: [
                        {
                            name: '[[[Edytuj komunikaty]]]',
                            route: 'core-notifications-types-edit',
                            auth: { all: ['NotificationsPermissions@Access'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Szablony email]]]',
                    route: 'core-notifications-templates',
                    icon: 'far fa-fw fa-ballot-check',
                    auth: { all: ['NotificationsPermissions@Access'], any: [] },
                    children: [
                        {
                            name: '[[[Dodaj szablon]]]',
                            route: 'core-notifications-templates-add',
                            auth: { all: ['NotificationsPermissions@Access'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edytuj szablon]]]',
                            route: 'core-notifications-templates-edit',
                            auth: { all: ['NotificationsPermissions@Access'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]
        }
    ]);
};
